import {getConfig} from './config';

export const navigation = {
  push(url: string) {
    const history = getConfig().history;

    if (history?.push) {
      history.push(url);
      return;
    }

    window.location.href = url;
  },
};